<template>
  <div>
    <filters :lot="lot" v-model="report">
    </filters>

    <report-table :lot="lot" :report="report">
    </report-table>
  </div>
</template>

<script>
  import Filters from './Filters'
  import ReportTable from './Table'
  import OldReportTable from './TableOld'


  export default {
    props: {
      lot: {
        type: Object,
        required: true
      }
    },

    components: {
      Filters,
      ReportTable,
      OldReportTable
    },

    data: () => ({
      report: undefined
    }),

    watch: {
      'lot.requests'() {
        console.info('updated lot.requests in report');
      },
      report() {
        console.info('updated report in report');
      },
      lot: {
        handler() {
          console.info('updated lot in report');
        },
        deep: true
      }
    },

    computed: {
      bestPositionEstimate() {
        return this.lot.specs.reduce((acc, e) => {
          if (!_.has(acc[e.position]) || e.estimate > acc[e.position]) {
            acc[e.position] = e.estimate;
          }
          return acc;
        }, {})
      },
    }
  }
</script>

<style scoped>

</style>
